import { render, staticRenderFns } from "./addBanPayChannel.vue?vue&type=template&id=3f100dc4&"
import script from "./addBanPayChannel.vue?vue&type=script&lang=js&"
export * from "./addBanPayChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports